import Link from "@/components/Link";
import Image from "next/image";
import React, { Fragment } from "react";

import { Paragraph } from "@cgc/ui/typography";
import { clsx } from "@cgc/ui/utils/clsx";

import { BlogSidebarItemProps, BlogSidebarProps } from "./types";

const BlogSidebarItem: React.FC<BlogSidebarItemProps> = ({
  url,
  title,
  image,
  alt = "",
  size = 256,
}) => (
  <div className="flex flex-col items-center">
    <Link href={url}>
      <Image src={image} alt={alt} width={size} height={size} />
    </Link>
    <Link href={url} className="no-underline">
      <Paragraph
        as={"span"}
        size={"sub3"}
        className="my-2 block text-center uppercase"
      >
        {title}
      </Paragraph>
    </Link>
  </div>
);

const BlogSidebar: React.FC<BlogSidebarProps> = ({ items, className }) => (
  <div className={clsx("bg-cgc-yellow-20 min-h-[300px] p-[25px]", className)}>
    {items.map((item, i) => (
      <Fragment key={`${item.url}:${i}`}>
        <BlogSidebarItem {...item} />
        <hr
          className={clsx(
            "mb-6 w-full border-b-[3px] border-t-0",
            i === 0 && "border-cgc-blue",
            i === 1 && "border-cgc-green",
            i === 2 && "border-cgc-yellow mb-0",
          )}
        />
      </Fragment>
    ))}
  </div>
);

export default BlogSidebar;
